"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getVersionManifest() {
    return {
        stage: process.env.REACT_APP_STAGE || 'local',
        name: process.env.REACT_APP_NAME || 'DEV',
        sha1: process.env.REACT_APP_VERSION_SHA1 || 'HEAD',
        date: process.env.REACT_APP_VERSION_DATE || new Date().toISOString(),
    };
}
exports.getVersionManifest = getVersionManifest;
//# sourceMappingURL=versionManifest.js.map